import { writable } from "svelte/store";

const Store = () => {
  const { subscribe, update } = writable<type_logined_user>({
    id: null,
    name: null,
    is_admin: false,
  });

  // 作成
  const regist = (user: type_logined_user) => {
    update((prev) => {
      return { ...prev, ...user };
    });
  };
  return { subscribe, regist };
};

export const userStore = Store();
